import { makeStyles } from '@material-ui/core/styles';
import formStyles from '../../Screens/GeneralStyles/formStyle';

const useStyles = makeStyles((theme) => {
  return {
    ...formStyles(theme),
    root: {
      margin: theme.spacing(2),
      // '&.MuiPaper-root': {
      //   backgroundColor: theme.palette.primary.transparent,
      // },
    },
    formButton: {
      color: `${theme.palette.primary.main} !important`,
      paddingBottom: `5px !important`
    },
    upcomingButton: { color: `${theme.palette.primary.main} !important` },
    intakeFormCallout: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(4),
      padding: theme.spacing(2, 3),
      textAlign: "center",
      position: "relative",
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      paddingLeft: theme.spacing(3),
      boxShadow: `inset 0 -1px 0 ${theme.palette.divider}`,

      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        paddingLeft: theme.spacing(2.5),
      },
    },
    intakeMessage: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.primary,
      lineHeight: 1.7,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
  };
  
});

export default useStyles;
